import $ from 'jquery';

export function showSpinner() {
	$('#button-factory-spinner').addClass('show');
}

export function hideSpinner() {
	$('#button-factory-spinner').removeClass('show');	
}



// WEBPACK FOOTER //
// ./buttons/utils/spinnerUtils.js